import type { QueryClient } from "@tanstack/react-query";
import {
  getPrivateLessonEntriesFromApi,
  type PrivateLessonsFilters,
} from "@/lib/services/privateLessonsService";
import { QueryKeys } from "@/lib/types";

export async function prefetchPrivateLessonsCalendar(
  queryClient: QueryClient,
  accessToken: string,
  filters: PrivateLessonsFilters,
) {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.PrivateLessonsCalendar, filters],
    queryFn: () => getPrivateLessonEntriesFromApi(accessToken, filters),
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}
